export const salesCallStatusMap = {
    Planlandı: 'Planned',
    Tamamlandı: 'Completed',
    'İptal Edildi': 'Cancelled',
    Ertelendi: 'Postponed',
    'Yüz Yüze': 'Face to Face',
    Telefon: 'Phone',
    'Video Konferans': 'Video Conference',
    'E-posta': 'Email',
    Başarılı: 'Successful',
    Başarısız: 'Unsuccessful',
    Beklemede: 'Pending',
    'Takip Gerekli': 'Follow-up Required',
};

export const getSalesCallStatusLabel = (s) => salesCallStatusMap[s] || s;
